import adamImg from './pictures/adam.png'
import beboImg from './pictures/bebo.png'
import samImg from './pictures/sam.png'
import maiuranImg from './pictures/maiuran.png'

type Testimonial = {
  img: string
  name: string
  position: string
  company: string
  quote: string
  backgroundImageUrl?: string
}

// large-style cartoon testimonials
const jared = {
  img: 'https://res.cloudinary.com/almanac/image/upload/v1715015489/blaze_assets/backgrounds/first_time_experience/jared_large_2x_trqrdj.png',
  backgroundImageUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1715015430/blaze_assets/backgrounds/first_time_experience/jared_background2x_agacaj.png',
  name: '<b>Jared Kinchen,</b>',
  position: 'CEO,',
  company: 'Novel Work Co.',
  quote:
    '"Blaze\'s multi channel campaigns definitely save us time. The quality of what Blaze produces is better than any other AI generator that we\'ve seen."',
}

const terry = {
  img: 'https://res.cloudinary.com/almanac/image/upload/v1715016788/blaze_assets/backgrounds/first_time_experience/terry_2x_sns0ja.png',
  backgroundImageUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1715016929/blaze_assets/backgrounds/first_time_experience/terry_background_2x_lwvj4l.png',
  name: '<b>Terry Wells,</b>',
  position: '',
  company: 'Small Business Marketing Strategist',
  quote: '“Blaze saves me two to three hours of work per client every week!"',
}

const rosanna = {
  img: 'https://res.cloudinary.com/almanac/image/upload/v1715017208/blaze_assets/backgrounds/first_time_experience/rosanna_2x_oni5vp.png',
  name: '<b>Rosanna Martinovic,</b>',
  position: 'Business Owner,',
  company: 'OnsiteHub',
  quote:
    "“Blaze was so easy to set up. You just plug in your website and basically, you get the exact same tone of voice and lingo that you're using already.”",
  backgroundImageUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1715017314/blaze_assets/backgrounds/first_time_experience/rosanna_2x_background_jhdjkl.png',
}

const jeremy = {
  img: 'https://res.cloudinary.com/almanac/image/upload/v1715017391/blaze_assets/backgrounds/first_time_experience/jeremy_2x_rdyb6o.png',
  quote:
    '“With Blaze, I improved my online SEO visibility and started to receive more calls from people curious about my product.”',
  name: '<b>Jeremy Schofield,</b>',
  position: 'CEO,',
  company: 'From Above Droneworks',
}
// end of larg cartoon testimonials

const bebo = {
  img: beboImg,
  name: 'Bebo Boe',
  position: 'Head of Marketing & Community',
  company: 'at Spark Creative Play',
  quote: '"Okay, this is just flat out impressive compared to other AI I have used."',
}

const jaredSmall = {
  img: 'https://res.cloudinary.com/almanac/image/upload/v1715632418/blaze_assets/backgrounds/first_time_experience/jaredSmall_hhwooz.png',
  quote:
    "“We're a small firm. We don't have a lot of time to do a lot of things marketing-related. <b>Blaze's multi channel campaigns definitely save us time.</b>\"",
  name: 'Jared Kinchen,',
  position: 'CEO,',
  company: 'Novel Work Co.',
}

const adam = {
  img: adamImg,
  name: 'Adam LaFaber',
  position: 'Owner of Digital',
  company: 'Sandwich Agency',
  quote: '"Gets me to my first draft Blazingly fast"',
}

const austin = {
  img: 'https://res.cloudinary.com/almanac/image/upload/v1715632379/blaze_assets/backgrounds/first_time_experience/austin_hqlu43.png',
  name: 'Austin Cornelio,',
  position: 'Founder,',
  company: 'Brio Interactive',
  quote:
    '"<b>One of the nicest things about Blaze is that it\'s super automated</b>. You can really just focus on your ideas and rapidly iterate on them. I really like that."',
}

const nick = {
  img: 'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/backgrounds/first_time_experience/nick',
  name: 'Nick Nyxson,',
  position: 'Online Instructor',
  company: '',
  quote:
    '"<b>Blaze is ridiculously easy to use, I expected it to work well, but not THAT well.</b>. I am honestly blown away how amazing it is."',
}

const nataly = {
  img: 'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/backgrounds/first_time_experience/nataly',
  name: 'Nataly Huff,',
  position: 'Marketing Executive',
  company: '',
  quote:
    '"I\'ve been using Jasper before this. And I am officially making the switch. <b>Blaze is cheaper, better, faster, and gets you from a blank page to something usable much faster.</b>"',
}

const danielle = {
  img: 'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/backgrounds/first_time_experience/danielle',
  name: 'Danielle Williams',
  position: '',
  company: '',
  quote: "\"I've been using Blaze and it's a great tool - <b>and it's legit - better than ChatGPT in my opinion.</b>\"",
}

const amanda = {
  img: 'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/backgrounds/first_time_experience/amanda',
  name: 'Amanda Katherine',
  position: '',
  company: '',
  quote:
    '"<b>Trialed for 1 day and then upgraded and paid for a year up front,</b> invited my team, and then updated my SOPs. Awesome product."',
}

const gabby = {
  img: 'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/backgrounds/first_time_experience/gabby',
  name: 'Gabby Alzate',
  position: 'Executive Director',
  company: '',
  quote:
    '"<b>I\'ve been hesitant to try AI. But Blaze comes up with content so much better than anything that I could create.</b> What would have taken me hours to create it creates in minutes."',
}

const roger = {
  img: 'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/backgrounds/first_time_experience/roger',
  name: 'Roger Elliott',
  position: 'Managing Director',
  company: '',
  quote:
    "\"<b>I'm no longer feeling like I'm failing on the social media front.</b> With Blaze, I can queue up the next month's worth of promotional tweets or quotes from articles.\"",
}

const iwan = {
  img: 'https://res.cloudinary.com/almanac/image/upload/v1715632500/blaze_assets/backgrounds/first_time_experience/iwan_k8cjeb.png',
  name: 'Iwan Roberts,',
  position: 'Business Owner,',
  company: 'Derw Digital',
  quote:
    '"<b>Blaze is just a brilliant tool to use</b>. Once you\'ve set up the brand voice in Blaze, the content you make just automatically sounds like your client. They are blown away!"',
}

const sam = {
  img: samImg,
  name: 'Sam Cassady',
  position: 'Marketing & Communication',
  company: 'Specialist at Ambassador Wines',
  quote: '"With Blaze, I turned one piece of content into a treasure trove of promotional gems!"',
}

const maiuran = {
  img: maiuranImg,
  name: 'Maiuran Loganathan',
  position: 'Partnerships At',
  company: 'Vimo Media',
  quote: '"This is a game changer - I\'m dropping ChatGPT and switching to Blaze"',
}

export const shuffledTestimonials = [austin, iwan, jaredSmall, nick, nataly, danielle, amanda, gabby, roger]

export const testimonials: { [key: string]: Testimonial } = {
  continueWithEmailOrGmail: bebo,
  usingGmail: bebo,
  usingEmailAndPassword: bebo,
  usingSamlSso: bebo,
  enterPassword: bebo,
  checkYourInboxForPasswordResetEmail: bebo,
  resetPassword: bebo,
  checkEmailOrEnterVerificationCode: adam,
  emailVerification: adam,
  createAccount: sam,
  blazeStartFreeTrial: maiuran,
}

export const largeCartoonTestimonials: { [key: string]: Testimonial } = {
  continueWithEmailOrGmail: jared,
  usingGmail: jared,
  usingEmailAndPassword: jared,
  enterPassword: jared,
  checkYourInboxForPasswordResetEmail: terry,
  createAccount: rosanna,
  blazeStartFreeTrial: jeremy,
}

export const newRegistrationTestimonials: { [key: string]: Testimonial } = {
  continueWithEmailOrGmail: austin,
  usingGmail: austin,
  usingEmailAndPassword: austin,
  usingSamlSso: bebo,
  enterPassword: austin,
  blazeStartFreeTrial: jaredSmall,
  checkYourInboxForPasswordResetEmail: bebo,
  resetPassword: bebo,
  checkEmailOrEnterVerificationCode: adam,
  emailVerification: adam,
  createAccount: iwan,
}
